import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import NotificationService from "../NotificationService";
import {
  startNotificationPolling,
  stopNotificationPolling,
} from "../../utils/notificationPolling";

const EMPLOYEE_UID_CHECK_MS = 2000;
const EMPLOYEE_UID_MAX_ATTEMPTS = 30;

/**
 * Keeps notification count polling alive for the whole authenticated session.
 * Lives at App root so route changes do not reset the 2-minute interval.
 */
const NotificationPollingBootstrap = () => {
  const location = useLocation();
  const pollingStartedRef = useRef(false);

  const isPublicRoute =
    location.pathname === "/login" || location.pathname === "/session-ended";

  useEffect(() => {
    if (isPublicRoute) {
      pollingStartedRef.current = false;
      stopNotificationPolling();
      return undefined;
    }

    const token = localStorage.getItem("access_token");
    if (!token) {
      pollingStartedRef.current = false;
      stopNotificationPolling();
      return undefined;
    }

    if (pollingStartedRef.current && NotificationService.getUserId()) {
      return undefined;
    }

    let uidWaitId = null;
    let attempts = 0;

    const ensurePolling = () => {
      const userId = NotificationService.getUserId();
      if (!userId) return false;

      startNotificationPolling(userId);
      pollingStartedRef.current = true;
      if (uidWaitId) {
        clearInterval(uidWaitId);
        uidWaitId = null;
      }
      return true;
    };

    if (!ensurePolling()) {
      uidWaitId = setInterval(() => {
        attempts += 1;
        if (ensurePolling() || attempts >= EMPLOYEE_UID_MAX_ATTEMPTS) {
          if (uidWaitId) {
            clearInterval(uidWaitId);
            uidWaitId = null;
          }
        }
      }, EMPLOYEE_UID_CHECK_MS);
    }

    return () => {
      if (uidWaitId) clearInterval(uidWaitId);
    };
  }, [isPublicRoute]);

  return null;
};

export default NotificationPollingBootstrap;
